module.exports = __webpack_public_path__ + "4e7a874ca67f066e1f5fdc544c5120fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/videos/file-setup.jpg
// module id = 141
// module chunks = 0